import React from 'react';
import { isNullOrUndefined } from '../../store/storeFunctions';
import ClassificationByLegalForm from "./summaryOverviewResults/summaryLocationViaFormResult";
import ClassificationByRegion from "./summaryOverviewResults/summaryLocationViaRegionResult";
import NoDataComponent from '../common/noDataComponent';
import Summary from "./summaryOverviewResults/summaryAll";
import SummaryHistory from "./summaryOverviewResults/summaryHistoryResult";

import "../../css/search/search.scss";

class RatioBookSummaryResult extends React.Component {
    state = {
        data: [],
        isLoading: false,
    };

    render() {
        const { year, summary, division } = this.props.computedMatch.params;
        if (isNullOrUndefined(year) || isNullOrUndefined(summary)|| isNullOrUndefined(division))
            return (<NoDataComponent />);

            switch(summary){
                case('01'):
                    return (<Summary year={year} summary={summary} division={division}></Summary>);
                case('02'):
                    return (<ClassificationByLegalForm year={year} summary={summary} division={division}></ClassificationByLegalForm>);
                case('03'):
                    return (<ClassificationByRegion year={year} summary={summary} division={division}></ClassificationByRegion>);
                case('04'):
                case('05'):
                case('06'):
                case('07'):
                case('08'):
                case('09'):
                case('10'):
                    return (<SummaryHistory year={year} summary={summary} division={division}></SummaryHistory>);
                default:
                    return (<NoDataComponent />);
            }    
    }
}

export default RatioBookSummaryResult;